export const rules = {
    required: value => !!value || 'Requerido.',
    min: value => {
        const minValue = 0;
        return value > minValue || `El número debe mayor a ${minValue}.`;
    },
    number: value => /^[0-9]+$/.test(value) || 'Solo se permiten números.'
}